import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <h2 style={styles.heading}>Something went wrong.</h2>
                        <p style={styles.text}>An unexpected error has occurred.</p>
                        <button
                            style={styles.button}
                            onClick={() => window.location.reload()}
                        >
                            Reload Page
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

// Simple inline styles to avoid external CSS dependencies
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: '#f9fafb',
        color: '#374151',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        padding: '20px',
        boxSizing: 'border-box',
    },
    content: {
        textAlign: 'center',
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        maxWidth: '400px',
        width: '100%',
    },
    heading: {
        marginBottom: '16px',
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
    },
    text: {
        marginBottom: '24px',
        fontSize: '16px',
        color: '#6b7280',
    },
    button: {
        padding: '12px 24px',
        backgroundColor: '#4f46e5', // Indigo-600
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
};

export default ErrorBoundary;
